// extracted by mini-css-extract-plugin
export default {"component-container":"accountManagement_component-container__juOnc","component-caption":"accountManagement_component-caption__-Uesl"};